"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var add_to_waitlist_modal_html_1 = __importDefault(require("./add-to-waitlist-modal/add-to-waitlist-modal.html"));
var add_to_waitlist_modal_controller_1 = __importDefault(require("./add-to-waitlist-modal/add-to-waitlist-modal.controller"));
var AdminWaitlistController = /** @class */ (function () {
    function AdminWaitlistController($window, $uibModal, WaitListModel, FlashService, courseTypes, sessionTypes) {
        this.$window = $window;
        this.$uibModal = $uibModal;
        this.WaitListModel = WaitListModel;
        this.FlashService = FlashService;
        this.sessionTypes = sessionTypes;
        this.courseTypes = courseTypes;
        this.loading = true;
        this.featureDisabled = false;
        this.waitListEntries = [];
        this.totalItems = 0;
        this.currentPage = 1;
        this.perPage = 15;
        this.filters = {
            type: "",
            booked: "",
            from: "",
            to: "",
        };
        this.updateFrom = this.updateFrom.bind(this);
        this.updateTo = this.updateTo.bind(this);
        this.loadWaitList();
    }
    AdminWaitlistController.prototype.loadWaitList = function () {
        var _this = this;
        this.loading = true;
        var params = {
            page: this.currentPage,
        };
        if (this.filters.type) {
            params.type = this.filters.type;
        }
        if (this.filters.booked !== "") {
            params.booked = this.filters.booked === "true" ? 1 : 0;
        }
        if (this.filters.from) {
            params.from = (0, time_1.toYMD)(new Date(this.filters.from));
        }
        if (this.filters.to) {
            params.to = (0, time_1.toYMD)(new Date(this.filters.to));
        }
        this.WaitListModel.getWaitLists(params)
            .then(function (response) {
            _this.waitListEntries = response.waitLists.data;
            _this.currentPage = response.waitLists.current_page;
            _this.totalItems = response.waitLists.total;
            _this.loading = false;
        })
            .catch(function (error) {
            if (error.status === 403) {
                _this.featureDisabled = true;
            }
            _this.loading = false;
        });
    };
    AdminWaitlistController.prototype.pageChanged = function () {
        this.loadWaitList();
    };
    AdminWaitlistController.prototype.applyFilters = function () {
        this.currentPage = 1;
        this.loadWaitList();
    };
    AdminWaitlistController.prototype.removeEntry = function (entry) {
        var _this = this;
        if (!this.$window.confirm("Are you sure you want to remove this waitlist entry?")) {
            return;
        }
        this.WaitListModel.destroy(entry.id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.waitListEntries = _this.waitListEntries.filter(function (e) { return e.id !== entry.id; });
        })
            .catch(function (response) {
            _this.FlashService.setMessage({
                type: "error",
                message: response.detail,
            });
        });
    };
    AdminWaitlistController.prototype.openAddModal = function () {
        var _this = this;
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: add_to_waitlist_modal_html_1.default,
            controller: add_to_waitlist_modal_controller_1.default,
            controllerAs: "vm",
            size: "md",
            resolve: {
                sessionTypes: function () { return _this.sessionTypes; },
                courseTypes: function () { return _this.courseTypes; },
            },
        });
        modalInstance.result.then(function () {
            _this.loadWaitList();
        }, function () {
            // modal dismissed
        });
    };
    AdminWaitlistController.prototype.updateFrom = function (newDate) {
        this.filters.from = newDate.selected[0];
    };
    AdminWaitlistController.prototype.updateTo = function (newDate) {
        this.filters.to = newDate.selected[0];
    };
    AdminWaitlistController.prototype.formatType = function (entry) {
        if (entry.wait_listable_type.indexOf("SessionType") !== -1) {
            return "Session Type";
        }
        if (entry.wait_listable_type.indexOf("CourseType") !== -1) {
            return "Course Type";
        }
        return entry.wait_listable_type;
    };
    AdminWaitlistController.prototype.isBooked = function (entry) {
        return entry.booked_at !== null;
    };
    AdminWaitlistController.prototype.formatDuration = function (minutes) {
        return (0, time_1.formatDuration)(minutes);
    };
    return AdminWaitlistController;
}());
AdminWaitlistController.$inject = [
    "$window",
    "$uibModal",
    "WaitListModel",
    "FlashService",
    "courseTypes",
    "sessionTypes",
];
exports.default = AdminWaitlistController;
